import { Link } from "react-router-dom";
import { Calendar, ChevronRight, Instagram, User } from "lucide-react";
import { getNoticiaBySlug } from "@/data/noticiasData";
import { shouldShowHomeNewsShortcut } from "@/lib/homeNewsShortcut";

const FEATURED_NEWS_SLUG = "ranking-paraiba-2026-lideres-etapa-2";

export default function HomeNewsShortcut() {
  if (!shouldShowHomeNewsShortcut()) return null;

  const featuredNews = getNoticiaBySlug(FEATURED_NEWS_SLUG);
  if (!featuredNews) return null;

  return (
    <section className="py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="card-fpf3 overflow-hidden border-primary/30">
          <div className="grid md:grid-cols-2 gap-0">
            {featuredNews.image && (
              <div className="relative aspect-[4/5] md:aspect-auto">
                <img
                  src={featuredNews.image}
                  alt={featuredNews.title}
                  className="w-full h-full object-cover"
                />
              </div>
            )}

            <div className="p-8 md:p-12 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 bg-primary text-primary-foreground text-xs font-bold uppercase tracking-wider rounded-sm mb-4 w-fit">
                {featuredNews.category}
              </span>

              <h2 className="text-2xl md:text-3xl font-black mb-4">{featuredNews.title}</h2>

              <p className="text-muted-foreground mb-6">{featuredNews.excerpt}</p>

              <div className="flex items-center gap-4 text-sm text-muted-foreground mb-6">
                <span className="flex items-center gap-1">
                  <Calendar size={14} />
                  {featuredNews.date}
                </span>
                <span className="flex items-center gap-1">
                  <User size={14} />
                  {featuredNews.author}
                </span>
              </div>

              {featuredNews.fullContent && (
                <div className="text-sm text-muted-foreground mb-6 whitespace-pre-line line-clamp-6">
                  {featuredNews.fullContent}
                </div>
              )}

              <div className="flex flex-wrap items-center gap-4">
                <Link
                  to={`/noticias/${featuredNews.slug}`}
                  className="flex items-center gap-2 text-primary font-semibold uppercase tracking-wider text-sm hover:gap-3 transition-all active:scale-95"
                >
                  Ler Mais
                  <ChevronRight size={16} />
                </Link>

                {featuredNews.instagramUrl && (
                  <a
                    href={featuredNews.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 border border-primary/30 text-primary font-semibold text-sm rounded-sm hover:bg-primary hover:text-primary-foreground transition-all duration-300"
                  >
                    <Instagram size={18} />
                    {featuredNews.instagramLabel || "@fpf3oficial"}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
